import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const formatStatusLabel = (s) => s.replace(/_/g, ' ');

/**
 * Reusable filter bar: search input + status dropdown.
 * The status options are passed in so each page can supply its own list.
 */
export default function TableFilters({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search...',
  searchTestId,
  statusValue,
  onStatusChange,
  statuses = [],
  statusTestId,
  statusLabel = formatStatusLabel,
}) {
  return (
    <div className="flex flex-col md:flex-row gap-3 mb-4">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
        <Input
          data-testid={searchTestId}
          placeholder={searchPlaceholder}
          className="pl-9"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <Select value={statusValue} onValueChange={onStatusChange}>
        <SelectTrigger className="w-full md:w-48" data-testid={statusTestId}>
          <SelectValue placeholder="Filter status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All statuses</SelectItem>
          {statuses.map((s) => (
            <SelectItem key={s} value={s}>{statusLabel(s)}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
